export const getServiceNameLabel = (name: string | null | undefined) => {
	if (!name) return null
	return name.split(' ').join('_').split('-').join('_').toLowerCase()
}
